/* eslint-disable no-use-before-define */
import DashboardService from '../../services/DashboardService';
import DashboardTypes from '../types/DashboardTypes';

//* get user count list items
function getAll(client, department, currency, rangeDate) {
  return async (dispatch) => {
    dispatch({ type: DashboardTypes.GET_DASHBOARD_ALL_ITEM_REQUEST });
    try {
      const res = await DashboardService.getAll(client, department, currency, rangeDate);
      dispatch({
        type: DashboardTypes.GET_DASHBOARD_ALL_ITEM_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: DashboardTypes.GET_DASHBOARD_ALL_ITEM_ERROR,
          error: error.response
        });
      }
      //
    }
  };
}

function getFilterOptions() {
  return async (dispatch) => {
    dispatch({ type: DashboardTypes.GET_FILTER_OPTIONS_REQUEST });
    try {
      const res = await DashboardService.getFilterOptions();
      dispatch({
        type: DashboardTypes.GET_FILTER_OPTIONS_SUCCESS,
        payload: res.data.data
      });
    } catch (error) {
      if (error && error.response) {
        dispatch({
          type: DashboardTypes.GET_FILTER_OPTIONS_ERROR,
          error: error.response
        });
      }
      //
    }
  };
}

const DashboardAction = {
  getAll,
  getFilterOptions
};

export default DashboardAction;
